import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const features = [
    { 
      title: 'Dashboard', 
      description: 'Monitor lab activity and stats', 
      icon: '📊',
      path: '/dashboard',
      color: 'from-blue-500 to-blue-600'
    },
    { 
      title: 'Samples', 
      description: 'Track and manage samples', 
      icon: '🧪',
      path: '/samples',
      color: 'from-green-500 to-green-600'
    },
    { 
      title: 'Dewars', 
      description: 'Cryogenic storage management', 
      icon: '❄️',
      path: '/dewars',
      color: 'from-indigo-500 to-indigo-600'
    },
    { 
      title: 'Reports', 
      description: 'Generate comprehensive reports', 
      icon: '📈',
      path: '/reports',
      color: 'from-purple-500 to-purple-600'
    },
    { 
      title: 'Users', 
      description: 'Manage team access', 
      icon: '👥',
      path: '/users',
      color: 'from-pink-500 to-pink-600'
    },
    { 
      title: 'Settings', 
      description: 'Configure preferences', 
      icon: '⚙️',
      path: '/settings',
      color: 'from-gray-500 to-gray-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        {/* Hero Section - Responsive */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6">
            CryoTracker Lab
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-3 sm:mb-4">
            Laboratory Sample Management System
          </p>
          <p className="text-sm sm:text-base md:text-lg text-gray-500 max-w-2xl mx-auto px-4">
            Comprehensive tracking and management for cryogenic storage
          </p>
        </div>

        {/* Features Grid - Responsive */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-12 sm:mb-16">
          {features?.map((feature, index) => (
            <Link
              key={index}
              to={feature?.path}
              className="group bg-white rounded-xl sm:rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              <div className={`bg-gradient-to-r ${feature?.color} p-4 sm:p-6`}>
                <span className="text-4xl sm:text-5xl lg:text-6xl">{feature?.icon}</span>
              </div>
              <div className="p-4 sm:p-6 lg:p-8">
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-2 sm:mb-3">
                  {feature?.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600">
                  {feature?.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        {/* Key Features Section - Responsive */}
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12 mb-8 sm:mb-12">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">
            Key Features
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {[
              'Real-time dewar monitoring and occupancy tracking',
              'Interactive 10x10 grid visualization for sample locations',
              'Role-based access controls for team collaboration',
              'Barcode integration and bulk operations support',
              'Comprehensive reporting and analytics dashboard',
              'Temperature monitoring and alert system'
            ]?.map((feature, index) => (
              <div key={index} className="flex items-start p-3 sm:p-4 bg-gray-50 rounded-lg">
                <span className="text-green-500 mr-2 sm:mr-3 text-lg sm:text-xl flex-shrink-0">✓</span>
                <span className="text-sm sm:text-base text-gray-700">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Status Footer - Responsive */}
        <div className="text-center">
          <p className="text-sm sm:text-base text-gray-600 mb-2">
            System Status: <span className="text-green-600 font-semibold">Operational</span>
          </p>
          <p className="text-xs sm:text-sm text-gray-400">
            Build complete • Ready for configuration
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;